import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { urlConstants } from '../../common/urlConstants';
import { HttpClient } from '@angular/common/http';
import { DocumentType } from '../../models/model';
import { WebUploadIndexingFields } from '../../models/index-fields'
import { Observable } from 'rxjs';
import { WebUploadResponseDto } from '../../models/webUpload';
@Injectable({
  providedIn: 'root'
})

export class WebUploadService {

  constructor(private readonly http: HttpClient) { }

  getDocumentTypeList(selectedBusinessArea: number, userGPID: string, systemId: string): Observable<DocumentType[]> {
    const routeUrl = `${environment.apiUrl}${urlConstants.GetDocumentTypesUploadURL}${userGPID}/${systemId}/${selectedBusinessArea}`;
    return this.http.get<DocumentType[]>(routeUrl);
  }

  getIndexFieldsBasedOnDoctype(selectedDocumentType: number, userGPID: string, systemId: string): Observable<WebUploadIndexingFields> {
    const routeUrl = `${environment.apiUrl}${urlConstants.GetDocumentTypeInfo}${userGPID}/${systemId}/${selectedDocumentType}`;
    return this.http.get<WebUploadIndexingFields>(routeUrl);
  }

  createDocumentWebUpload(formData: FormData): Observable<WebUploadResponseDto> {
    const routeUrl = `${environment.apiUrl}${urlConstants.createDocument}`;
    return this.http.post<WebUploadResponseDto>(routeUrl, formData);
  }
}
